<template>
  <div v-if="!!areas.length" class="flex flex-col gap-4">
    <div v-for="(area, index) in areas">
      <input
        type="checkbox"
        name="areaCode"
        :id="area.value"
        :value="area.value"
        :key="area.value"
        :checked="internalValue === area.value"
        class="peer hidden"
        @change="onChange(area.value)"
      />

      <Label :val="area.value" :id="area.value" :name="area.name" :internalValue="internalValue" :onChange="onChange" />
    </div>
  </div>
</template>


<script>
import Label from '@/components/ui/label';


export default {
  name: 'ChooseArea',
  components: { Label },
  props: {
    areaCode: {
      default: null,
    },
    dir: {
      required: false
    },
  },
  emits: ['update:areaCode', 'change'],
  data() {
    return {
      internalValue: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      },
    },
  },
  computed: {
    /**
     * Area, t.ex. Lägenhet, Gemensamma utrymmenb....
     *
     * men ta bara med de som jag har kontrakt på, eller de som inte förväntas väljas kontrkat på.
     */
    areas() {
      const allAreas = this.$store.getters.getBaseCategories;
      return allAreas;
    },
  },
  methods: {
    onChange(value) {
      // Om användaren klickar på samma val igen → avmarkera
      if (this.internalValue === value) {
        this.internalValue = null;
        this.$emit('update:areaCode', null);
        this.$emit('change', null);
      } else {
        this.internalValue = value;
        this.$emit('update:areaCode', value);
        this.$emit('change', value);
      }
    },
  },
  created() {
    this.internalValue = this.areaCode;
    if (this.areaCode && this.dir =="prev") this.$emit('update:areaCode', this.internalValue);
  },
};
</script>
